import React, { useContext } from "react";
import { FilterColumnContext, TabValue } from "./context";
import ColumnButton from "./Button";
import Drawer from "./Drawer";

type FilterColumnProps = {
  columns: { key: string; label: string }[];
  checked: string[];
  open: boolean;
  handleResetButton: () => void;
  handleCancelButton: () => void;
  toggleSlider: () => void;
  handleChangeSwitcher: (name: string) => void;
  handleSelectAllButton: () => void;
  handleDeselectAllButton: () => void;
  handleReorder?: (key: number, position: number) => void;
};

const tabsWithColumnManagement = [TabValue.Info];

const FilterColumn = ({
  columns,
  checked,
  open,
  handleResetButton,
  toggleSlider,
  handleChangeSwitcher,
  handleCancelButton,
  handleSelectAllButton,
  handleDeselectAllButton,
  handleReorder,
}: FilterColumnProps): React.ReactElement => {
  const { disabledForHideColumnsList, tabValue, tabName } =
    useContext(FilterColumnContext);
  const alwaysShowFilter = ["Accounts", "Locations", "Users", "Tickets"];

  return (
    <>
      {(tabsWithColumnManagement.includes(tabValue) ||
        alwaysShowFilter.includes(tabName as string)) && (
        <ColumnButton onClick={toggleSlider} />
      )}
      <Drawer
        open={open}
        onClose={toggleSlider}
        onReset={handleResetButton}
        onCancel={handleCancelButton}
        onSelectAll={handleSelectAllButton}
        onDeselectAll={handleDeselectAllButton}
        handleSelection={handleChangeSwitcher}
        handleReorder={handleReorder}
        disabled={disabledForHideColumnsList}
        selected={checked}
        columns={columns}
      />
    </>
  );
};

export default FilterColumn;
